import decode from "jwt-decode";

import { Permission } from "shared/types";

type TokenClaims = {
  exp: number;
  role: Permission;
};

type AuthStatus =
  | { status: "anonymous" }
  | { status: "invalid"; error: unknown }
  | { status: "expired"; permission: Permission }
  | { status: "authenticated"; permission: Permission };

const evaluateAuthToken = (token: string | null): AuthStatus => {
  if (token === null) {
    return { status: "anonymous" };
  }

  try {
    const { exp, role: permission } = decode<TokenClaims>(token);
    const status = exp - Date.now() / 1000 <= 0 ? "expired" : "authenticated";

    return { status, permission };
  } catch (error) {
    return { status: "invalid", error };
  }
};

export { evaluateAuthToken };
export type { AuthStatus };
